import { Link, LinkProps } from '@mui/material';
import { ReactNode, forwardRef, MouseEvent } from 'react';

export const BaseLink = forwardRef<HTMLAnchorElement, BaseLinkProps>(({ children, onClick, ...otherProps }, ref) => {
  const isJavascriptUrl = typeof otherProps.href === 'string' && otherProps.href.startsWith('javascript:');
  const href = isJavascriptUrl ? '#' : otherProps.href;

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (isJavascriptUrl) {
      event.preventDefault();
    }
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <Link {...otherProps} href={href} onClick={handleClick} ref={ref}>
      {children}
    </Link>
  );
});

interface BaseLinkProps extends Omit<LinkProps, 'children'> {
  children: ReactNode;
}
